var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 230.1 216.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4b494b;\n        opacity: .69;\n      }\n\n      .cls-2 {\n        fill: #525052;\n        opacity: .64;\n      }\n\n      .cls-3 {\n        fill: #646365;\n        opacity: .5;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: #424041;\n        opacity: .76;\n      }\n\n      .cls-6 {\n        fill: #96989a;\n        opacity: .12;\n      }\n\n      .cls-7 {\n        fill: #a5a7aa;\n        opacity: 0;\n      }\n\n      .cls-8 {\n        fill: #474547;\n        opacity: .72;\n      }\n\n      .cls-9 {\n        fill: #343132;\n        opacity: .87;\n      }\n\n      .cls-10 {\n        fill: #828284;\n        opacity: .28;\n      }\n\n      .cls-11 {\n        fill: #87878a;\n        opacity: .24;\n      }\n\n      .cls-12 {\n        fill: #88898b;\n        opacity: .23;\n      }\n\n      .cls-13 {\n        fill: #717073;\n        opacity: .41;\n      }\n\n      .cls-14 {\n        fill: #5c5b5d;\n        opacity: .56;\n      }\n\n      .cls-15 {\n        fill: #413e40;\n        opacity: .77;\n      }\n\n      .cls-16 {\n        fill: #393637;\n        opacity: .83;\n      }\n\n      .cls-17 {\n        fill: #777779;\n        opacity: .36;\n      }\n\n      .cls-18 {\n        fill: #403d3e;\n        opacity: .78;\n      }\n\n      .cls-19 {\n        fill: #6e6e70;\n        opacity: .43;\n      }\n\n      .cls-20 {\n        fill: #5d5c5e;\n        opacity: .55;\n      }\n\n      .cls-21 {\n        fill: #8f9092;\n        opacity: .18;\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-23 {\n        fill: #808183;\n        opacity: .29;\n      }\n\n      .cls-24 {\n        fill: #999a9d;\n        opacity: .1;\n      }\n\n      .cls-25 {\n        fill: #585758;\n        opacity: .59;\n      }\n\n      .cls-26 {\n        isolation: isolate;\n      }\n\n      .cls-27 {\n        fill: #7a7a7c;\n        opacity: .34;\n      }\n\n      .cls-28 {\n        fill: #949598;\n        opacity: .14;\n      }\n\n      .cls-29 {\n        fill: #4f4d4f;\n        opacity: .66;\n      }\n\n      .cls-30 {\n        fill: #757477;\n        opacity: .38;\n      }\n\n      .cls-31 {\n        fill: #5b595b;\n        opacity: .57;\n      }\n\n      .cls-32 {\n        fill: #434142;\n        opacity: .75;\n      }\n\n      .cls-33 {\n        fill: #868689;\n        opacity: .25;\n      }\n\n      .cls-34 {\n        fill: #898a8d;\n        opacity: .22;\n      }\n\n      .cls-35 {\n        fill: #2b2728;\n        opacity: .94;\n      }\n\n      .cls-36 {\n        fill: #848587;\n        opacity: .26;\n      }\n\n      .cls-37 {\n        fill: #282426;\n        opacity: .96;\n      }\n\n      .cls-38 {\n        fill: #383536;\n        opacity: .84;\n      }\n\n      .cls-39 {\n        fill: #272324;\n        opacity: .97;\n      }\n\n      .cls-40 {\n        fill: #9d9fa1;\n        opacity: .07;\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-42 {\n        fill: #69686a;\n        opacity: .47;\n      }\n\n      .cls-43 {\n        fill: #454244;\n        opacity: .74;\n      }\n\n      .cls-44 {\n        fill: #9a9c9f;\n        opacity: .09;\n      }\n\n      .cls-45 {\n        fill: #353233;\n        opacity: .86;\n      }\n\n      .cls-46 {\n        fill: #98999c;\n        opacity: .11;\n      }\n\n      .cls-47 {\n        fill: #332f31;\n        opacity: .88;\n      }\n\n      .cls-48 {\n        fill: #545354;\n        opacity: .62;\n      }\n\n      .cls-49 {\n        fill: #8c8d8f;\n        opacity: .2;\n      }\n\n      .cls-50 {\n        fill: #504e50;\n        opacity: .65;\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-52 {\n        fill: #9c9da0;\n        opacity: .08;\n      }\n\n      .cls-53 {\n        fill: #262223;\n        opacity: .98;\n      }\n\n      .cls-54 {\n        fill: #a2a4a7;\n        opacity: .03;\n      }\n\n      .cls-55 {\n        fill: #2d2a2b;\n        opacity: .92;\n      }\n\n      .cls-56 {\n        fill: #494648;\n        opacity: .71;\n      }\n\n      .cls-57 {\n        fill: #9ea0a3;\n        opacity: .06;\n      }\n\n      .cls-58 {\n        fill: #737375;\n        opacity: .39;\n      }\n\n      .cls-59 {\n        fill: #7c7d7f;\n        opacity: .32;\n      }\n\n      .cls-60 {\n        opacity: .3;\n      }\n\n      .cls-61 {\n        fill: #3d3a3c;\n        opacity: .8;\n      }\n\n      .cls-62 {\n        fill: #959699;\n        opacity: .13;\n      }\n\n      .cls-63 {\n        fill: #8b8c8e;\n        opacity: .21;\n      }\n\n      .cls-64 {\n        fill: #2c282a;\n        opacity: .93;\n      }\n\n      .cls-65 {\n        fill: #686769;\n        opacity: .48;\n      }\n\n      .cls-66 {\n        fill: #a0a1a4;\n        opacity: .05;\n      }\n\n      .cls-67 {\n        fill: #605f61;\n        opacity: .53;\n      }\n\n      .cls-68 {\n        fill: #636163;\n        opacity: .51;\n      }\n\n      .cls-69 {\n        fill: #535153;\n        opacity: .63;\n      }\n\n      .cls-70 {\n        fill: #666668;\n        opacity: .49;\n      }\n\n      .cls-71 {\n        fill: #4a4849;\n        opacity: .7;\n      }\n\n      .cls-72 {\n        fill: #312e2f;\n        opacity: .89;\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-74 {\n        fill: #5f5d5f;\n        opacity: .54;\n      }\n\n      .cls-75 {\n        fill: #909194;\n        opacity: .17;\n      }\n\n      .cls-76 {\n        fill: #242021;\n        opacity: .99;\n      }\n\n      .cls-77 {\n        fill: #7b7b7e;\n        opacity: .33;\n      }\n\n      .cls-78 {\n        fill: #3e3b3d;\n        opacity: .79;\n      }\n\n      .cls-79 {\n        fill: #919295;\n        opacity: .16;\n      }\n\n      .cls-80 {\n        fill: #656466;\n        opacity: .5;\n      }\n\n      .cls-81 {\n        fill: #2f2b2c;\n        opacity: .91;\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-83 {\n        fill: #4e4c4d;\n        opacity: .67;\n      }\n\n      .cls-84 {\n        fill: #a1a3a5;\n        opacity: .04;\n      }\n\n      .cls-85 {\n        fill: #a3a5a8;\n        opacity: .02;\n      }\n\n      .cls-86 {\n        fill: #767678;\n        opacity: .37;\n      }\n\n      .cls-87 {\n        fill: #292627;\n        opacity: .95;\n      }\n\n      .cls-88 {\n        fill: #939496;\n        opacity: .15;\n      }\n\n      .cls-89 {\n        fill: #3a3739;\n        opacity: .82;\n      }\n\n      .cls-90 {\n        fill: #616062;\n        opacity: .52;\n      }\n\n      .cls-91 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-92 {\n        fill: #6d6c6e;\n        opacity: .44;\n      }\n\n      .cls-93 {\n        fill: #3c393a;\n        opacity: .81;\n      }\n\n      .cls-94 {\n        fill: #a6a8ab;\n        mix-blend-mode: multiply;\n        opacity: 0;\n      }\n\n      .cls-95 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-96 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-97 {\n        fill: #464445;\n        opacity: .73;\n      }\n\n      .cls-98 {\n        fill: #59585a;\n        opacity: .58;\n      }\n\n      .cls-99 {\n        fill: #565456;\n        opacity: .61;\n      }\n\n      .cls-100 {\n        fill: #4d4a4c;\n        opacity: .68;\n      }\n\n      .cls-101 {\n        fill: #363335;\n        opacity: .85;\n      }\n\n      .cls-102 {\n        fill: #7f7f82;\n        opacity: .3;\n      }\n\n      .cls-103 {\n        fill: #6a6a6c;\n        opacity: .46;\n      }\n\n      .cls-104 {\n        fill: #575557;\n        opacity: .6;\n      }\n\n      .cls-105 {\n        fill: #706f71;\n        opacity: .42;\n      }\n\n      .cls-106 {\n        fill: #231f20;\n      }\n\n      .cls-107 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-108 {\n        fill: #727274;\n        opacity: .4;\n      }\n\n      .cls-109 {\n        fill: #6c6b6d;\n        opacity: .45;\n      }\n\n      .cls-110 {\n        fill: #7e7e80;\n        opacity: .31;\n      }\n\n      .cls-111 {\n        fill: #8d8e91;\n        opacity: .19;\n      }\n\n      .cls-112 {\n        fill: #838386;\n        opacity: .27;\n      }\n\n      .cls-113 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-114 {\n        fill: #302d2e;\n        opacity: .9;\n      }\n\n      .cls-115 {\n        fill: #79797b;\n        opacity: .35;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 345.32,
    y1: -101.25,
    x2: 77.1,
    y2: 107.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8bc53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#20a247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 400.79,
    y1: -30.07,
    x2: 132.56,
    y2: 178.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 375.24,
    y1: -63.37,
    x2: 107.02,
    y2: 145.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 394.88,
    y1: -35.8,
    x2: 126.65,
    y2: 173.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 370.52,
    y1: -68.91,
    x2: 102.29,
    y2: 140.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 232.67,
    y1: -10.55,
    x2: 107.27,
    y2: 197.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 152.88,
    y1: -58.6,
    x2: 27.48,
    y2: 149.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 267.31,
    y1: 10.31,
    x2: 141.91,
    y2: 218.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 244.19,
    y1: -2.88,
    x2: 118.79,
    y2: 205.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 271.86,
    y1: 14.9,
    x2: 146.46,
    y2: 223.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 247.93,
    y1: -1.89,
    x2: 121.69,
    y2: 207.73,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m207.08,203.24c0,7.1-46.36,12.85-103.54,12.85S0,210.33,0,203.24s46.36-12.85,103.54-12.85,103.54,5.75,103.54,12.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m206.19,203.24c0,7.04-45.96,12.74-102.65,12.74S.89,210.27.89,203.24s45.96-12.74,102.65-12.74,102.65,5.7,102.65,12.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m205.31,203.24c0,6.98-45.56,12.63-101.77,12.63S1.78,210.21,1.78,203.24s45.56-12.63,101.77-12.63,101.77,5.65,101.77,12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m204.42,203.24c0,6.91-45.16,12.52-100.88,12.52S2.66,210.15,2.66,203.24s45.16-12.52,100.88-12.52,100.88,5.61,100.88,12.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m203.53,203.24c0,6.85-44.77,12.41-99.99,12.41S3.55,210.09,3.55,203.24s44.77-12.41,99.99-12.41,99.99,5.56,99.99,12.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m202.64,203.24c0,6.79-44.37,12.3-99.1,12.3s-99.1-5.51-99.1-12.3,44.37-12.3,99.1-12.3,99.1,5.51,99.1,12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m201.75,203.24c0,6.73-43.97,12.19-98.21,12.19s-98.21-5.46-98.21-12.19,43.97-12.19,98.21-12.19,98.21,5.46,98.21,12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m200.87,203.24c0,6.67-43.57,12.08-97.33,12.08s-97.33-5.41-97.33-12.08,43.57-12.08,97.33-12.08,97.33,5.41,97.33,12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m199.98,203.24c0,6.61-43.18,11.97-96.44,11.97s-96.44-5.36-96.44-11.97,43.18-11.97,96.44-11.97,96.44,5.36,96.44,11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m199.09,203.24c0,6.55-42.78,11.86-95.55,11.86s-95.55-5.31-95.55-11.86,42.78-11.86,95.55-11.86,95.55,5.31,95.55,11.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m198.2,203.24c0,6.49-42.38,11.75-94.66,11.75s-94.66-5.26-94.66-11.75,42.38-11.75,94.66-11.75,94.66,5.26,94.66,11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m197.32,203.24c0,6.43-41.98,11.64-93.77,11.64s-93.77-5.21-93.77-11.64,41.98-11.64,93.77-11.64,93.77,5.21,93.77,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m196.43,203.24c0,6.37-41.59,11.53-92.89,11.53s-92.89-5.16-92.89-11.53,41.59-11.53,92.89-11.53,92.89,5.16,92.89,11.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m195.54,203.24c0,6.31-41.19,11.42-92,11.42s-92-5.11-92-11.42,41.19-11.42,92-11.42,92,5.11,92,11.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m194.65,203.24c0,6.25-40.79,11.31-91.11,11.31s-91.11-5.06-91.11-11.31,40.79-11.31,91.11-11.31,91.11,5.06,91.11,11.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m193.76,203.24c0,6.18-40.39,11.2-90.22,11.2s-90.22-5.01-90.22-11.2,40.39-11.2,90.22-11.2,90.22,5.01,90.22,11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m192.88,203.24c0,6.12-40,11.09-89.34,11.09s-89.34-4.96-89.34-11.09,40-11.09,89.34-11.09,89.34,4.96,89.34,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m191.99,203.24c0,6.06-39.6,10.98-88.45,10.98s-88.45-4.92-88.45-10.98,39.6-10.98,88.45-10.98,88.45,4.91,88.45,10.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m191.1,203.24c0,6-39.2,10.87-87.56,10.87s-87.56-4.87-87.56-10.87,39.2-10.87,87.56-10.87,87.56,4.87,87.56,10.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m190.21,203.24c0,5.94-38.8,10.76-86.67,10.76s-86.67-4.82-86.67-10.76,38.8-10.76,86.67-10.76,86.67,4.82,86.67,10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m189.32,203.24c0,5.88-38.41,10.65-85.78,10.65s-85.78-4.77-85.78-10.65,38.41-10.65,85.78-10.65,85.78,4.77,85.78,10.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m188.44,203.24c0,5.82-38.01,10.54-84.9,10.54s-84.9-4.72-84.9-10.54,38.01-10.54,84.9-10.54,84.9,4.72,84.9,10.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m187.55,203.24c0,5.76-37.61,10.43-84.01,10.43s-84.01-4.67-84.01-10.43,37.61-10.43,84.01-10.43,84.01,4.67,84.01,10.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m186.66,203.24c0,5.7-37.21,10.32-83.12,10.32s-83.12-4.62-83.12-10.32,37.21-10.32,83.12-10.32,83.12,4.62,83.12,10.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m185.77,203.24c0,5.64-36.82,10.21-82.23,10.21s-82.23-4.57-82.23-10.21,36.82-10.21,82.23-10.21,82.23,4.57,82.23,10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m184.89,203.24c0,5.58-36.42,10.1-81.34,10.1s-81.34-4.52-81.34-10.1,36.42-10.1,81.34-10.1,81.34,4.52,81.34,10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m184,203.24c0,5.52-36.02,9.99-80.46,9.99s-80.46-4.47-80.46-9.99,36.02-9.99,80.46-9.99,80.46,4.47,80.46,9.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m183.11,203.24c0,5.45-35.62,9.88-79.57,9.88s-79.57-4.42-79.57-9.88,35.62-9.88,79.57-9.88,79.57,4.42,79.57,9.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m182.22,203.24c0,5.39-35.23,9.77-78.68,9.77s-78.68-4.37-78.68-9.77,35.23-9.77,78.68-9.77,78.68,4.37,78.68,9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m181.33,203.24c0,5.33-34.83,9.66-77.79,9.66s-77.79-4.32-77.79-9.66,34.83-9.66,77.79-9.66,77.79,4.32,77.79,9.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m180.45,203.24c0,5.27-34.43,9.55-76.91,9.55s-76.91-4.27-76.91-9.55,34.43-9.55,76.91-9.55,76.91,4.27,76.91,9.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "m179.56,203.24c0,5.21-34.03,9.44-76.02,9.44s-76.02-4.22-76.02-9.44,34.03-9.44,76.02-9.44,76.02,4.22,76.02,9.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m178.67,203.24c0,5.15-33.64,9.33-75.13,9.33s-75.13-4.18-75.13-9.33,33.64-9.32,75.13-9.32,75.13,4.17,75.13,9.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m177.78,203.24c0,5.09-33.24,9.21-74.24,9.21s-74.24-4.13-74.24-9.21,33.24-9.21,74.24-9.21,74.24,4.13,74.24,9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m176.89,203.24c0,5.03-32.84,9.1-73.35,9.1s-73.35-4.08-73.35-9.1,32.84-9.1,73.35-9.1,73.35,4.08,73.35,9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "m176.01,203.24c0,4.97-32.44,8.99-72.47,8.99s-72.47-4.03-72.47-8.99,32.44-8.99,72.47-8.99,72.47,4.03,72.47,8.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m175.12,203.24c0,4.91-32.05,8.88-71.58,8.88s-71.58-3.98-71.58-8.88,32.05-8.88,71.58-8.88,71.58,3.98,71.58,8.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m174.23,203.24c0,4.85-31.65,8.77-70.69,8.77s-70.69-3.93-70.69-8.77,31.65-8.77,70.69-8.77,70.69,3.93,70.69,8.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m173.34,203.24c0,4.78-31.25,8.66-69.8,8.66s-69.8-3.88-69.8-8.66,31.25-8.66,69.8-8.66,69.8,3.88,69.8,8.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m172.46,203.24c0,4.72-30.85,8.55-68.91,8.55s-68.91-3.83-68.91-8.55,30.85-8.55,68.91-8.55,68.91,3.83,68.91,8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m171.57,203.24c0,4.66-30.46,8.44-68.03,8.44s-68.03-3.78-68.03-8.44,30.46-8.44,68.03-8.44,68.03,3.78,68.03,8.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m170.68,203.24c0,4.6-30.06,8.33-67.14,8.33s-67.14-3.73-67.14-8.33,30.06-8.33,67.14-8.33,67.14,3.73,67.14,8.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m169.79,203.24c0,4.54-29.66,8.22-66.25,8.22s-66.25-3.68-66.25-8.22,29.66-8.22,66.25-8.22,66.25,3.68,66.25,8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m168.9,203.24c0,4.48-29.26,8.11-65.36,8.11s-65.36-3.63-65.36-8.11,29.26-8.11,65.36-8.11,65.36,3.63,65.36,8.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m168.02,203.24c0,4.42-28.87,8-64.48,8s-64.48-3.58-64.48-8,28.87-8,64.48-8,64.48,3.58,64.48,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m167.13,203.24c0,4.36-28.47,7.89-63.59,7.89s-63.59-3.53-63.59-7.89,28.47-7.89,63.59-7.89,63.59,3.53,63.59,7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m166.24,203.24c0,4.3-28.07,7.78-62.7,7.78s-62.7-3.48-62.7-7.78,28.07-7.78,62.7-7.78,62.7,3.48,62.7,7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m165.35,203.24c0,4.24-27.67,7.67-61.81,7.67s-61.81-3.44-61.81-7.67,27.67-7.67,61.81-7.67,61.81,3.43,61.81,7.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m164.47,203.24c0,4.18-27.28,7.56-60.92,7.56s-60.92-3.39-60.92-7.56,27.28-7.56,60.92-7.56,60.92,3.39,60.92,7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m163.58,203.24c0,4.12-26.88,7.45-60.04,7.45s-60.04-3.34-60.04-7.45,26.88-7.45,60.04-7.45,60.04,3.34,60.04,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m162.69,203.24c0,4.05-26.48,7.34-59.15,7.34s-59.15-3.29-59.15-7.34,26.48-7.34,59.15-7.34,59.15,3.29,59.15,7.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m161.8,203.24c0,3.99-26.08,7.23-58.26,7.23s-58.26-3.24-58.26-7.23,26.08-7.23,58.26-7.23,58.26,3.24,58.26,7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m160.91,203.24c0,3.93-25.69,7.12-57.37,7.12s-57.37-3.19-57.37-7.12,25.69-7.12,57.37-7.12,57.37,3.19,57.37,7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "m160.03,203.24c0,3.87-25.29,7.01-56.48,7.01s-56.48-3.14-56.48-7.01,25.29-7.01,56.48-7.01,56.48,3.14,56.48,7.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m159.14,203.24c0,3.81-24.89,6.9-55.6,6.9s-55.6-3.09-55.6-6.9,24.89-6.9,55.6-6.9,55.6,3.09,55.6,6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m158.25,203.24c0,3.75-24.49,6.79-54.71,6.79s-54.71-3.04-54.71-6.79,24.49-6.79,54.71-6.79,54.71,3.04,54.71,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m157.36,203.24c0,3.69-24.1,6.68-53.82,6.68s-53.82-2.99-53.82-6.68,24.1-6.68,53.82-6.68,53.82,2.99,53.82,6.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m156.47,203.24c0,3.63-23.7,6.57-52.93,6.57s-52.93-2.94-52.93-6.57,23.7-6.57,52.93-6.57,52.93,2.94,52.93,6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m155.59,203.24c0,3.57-23.3,6.46-52.05,6.46s-52.05-2.89-52.05-6.46,23.3-6.46,52.05-6.46,52.05,2.89,52.05,6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m154.7,203.24c0,3.51-22.9,6.35-51.16,6.35s-51.16-2.84-51.16-6.35,22.9-6.35,51.16-6.35,51.16,2.84,51.16,6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m153.81,203.24c0,3.45-22.51,6.24-50.27,6.24s-50.27-2.79-50.27-6.24,22.51-6.24,50.27-6.24,50.27,2.79,50.27,6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m152.92,203.24c0,3.38-22.11,6.13-49.38,6.13s-49.38-2.74-49.38-6.13,22.11-6.13,49.38-6.13,49.38,2.74,49.38,6.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m152.04,203.24c0,3.32-21.71,6.02-48.49,6.02s-48.49-2.69-48.49-6.02,21.71-6.02,48.49-6.02,48.49,2.69,48.49,6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m151.15,203.24c0,3.26-21.31,5.91-47.61,5.91s-47.61-2.65-47.61-5.91,21.31-5.91,47.61-5.91,47.61,2.65,47.61,5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m150.26,203.24c0,3.2-20.92,5.8-46.72,5.8s-46.72-2.6-46.72-5.8,20.92-5.8,46.72-5.8,46.72,2.6,46.72,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.37,203.24c0,3.14-20.52,5.69-45.83,5.69s-45.83-2.55-45.83-5.69,20.52-5.69,45.83-5.69,45.83,2.55,45.83,5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m148.48,203.24c0,3.08-20.12,5.58-44.94,5.58s-44.94-2.5-44.94-5.58,20.12-5.58,44.94-5.58,44.94,2.5,44.94,5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m147.6,203.24c0,3.02-19.72,5.47-44.05,5.47s-44.05-2.45-44.05-5.47,19.72-5.47,44.05-5.47,44.05,2.45,44.05,5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m146.71,203.24c0,2.96-19.33,5.36-43.17,5.36s-43.17-2.4-43.17-5.36,19.33-5.36,43.17-5.36,43.17,2.4,43.17,5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m145.82,203.24c0,2.9-18.93,5.25-42.28,5.25s-42.28-2.35-42.28-5.25,18.93-5.25,42.28-5.25,42.28,2.35,42.28,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m144.93,203.24c0,2.84-18.53,5.14-41.39,5.14s-41.39-2.3-41.39-5.14,18.53-5.14,41.39-5.14,41.39,2.3,41.39,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m144.04,203.24c0,2.78-18.13,5.03-40.5,5.03s-40.5-2.25-40.5-5.03,18.13-5.03,40.5-5.03,40.5,2.25,40.5,5.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m143.16,203.24c0,2.72-17.74,4.92-39.62,4.92s-39.62-2.2-39.62-4.92,17.74-4.92,39.62-4.92,39.62,2.2,39.62,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m142.27,203.24c0,2.65-17.34,4.81-38.73,4.81s-38.73-2.15-38.73-4.81,17.34-4.81,38.73-4.81,38.73,2.15,38.73,4.81Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-97",
    cx: 103.54,
    cy: 203.24,
    rx: 37.84,
    ry: 4.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 103.54,
    cy: 203.24,
    rx: 36.95,
    ry: 4.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 103.54,
    cy: 203.24,
    rx: 36.06,
    ry: 4.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 103.54,
    cy: 203.24,
    rx: 35.18,
    ry: 4.37
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 103.54,
    cy: 203.24,
    rx: 34.29,
    ry: 4.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 103.54,
    cy: 203.24,
    rx: 33.4,
    ry: 4.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-78",
    cx: 103.54,
    cy: 203.24,
    rx: 32.51,
    ry: 4.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-61",
    cx: 103.54,
    cy: 203.24,
    rx: 31.62,
    ry: 3.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-93",
    cx: 103.54,
    cy: 203.24,
    rx: 30.74,
    ry: 3.82
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 103.54,
    cy: 203.24,
    rx: 29.85,
    ry: 3.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 103.54,
    cy: 203.24,
    rx: 28.96,
    ry: 3.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-38",
    cx: 103.54,
    cy: 203.24,
    rx: 28.07,
    ry: 3.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-101",
    cx: 103.54,
    cy: 203.24,
    rx: 27.19,
    ry: 3.37
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-45",
    cx: 103.54,
    cy: 203.24,
    rx: 26.3,
    ry: 3.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 103.54,
    cy: 203.24,
    rx: 25.41,
    ry: 3.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-47",
    cx: 103.54,
    cy: 203.24,
    rx: 24.52,
    ry: 3.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-72",
    cx: 103.54,
    cy: 203.24,
    rx: 23.63,
    ry: 2.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-114",
    cx: 103.54,
    cy: 203.24,
    rx: 22.75,
    ry: 2.82
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-81",
    cx: 103.54,
    cy: 203.24,
    rx: 21.86,
    ry: 2.71
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-55",
    cx: 103.54,
    cy: 203.24,
    rx: 20.97,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-64",
    cx: 103.54,
    cy: 203.24,
    rx: 20.08,
    ry: 2.49
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 103.54,
    cy: 203.24,
    rx: 19.19,
    ry: 2.38
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-87",
    cx: 103.54,
    cy: 203.24,
    rx: 18.31,
    ry: 2.27
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-37",
    cx: 103.54,
    cy: 203.24,
    rx: 17.42,
    ry: 2.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 103.54,
    cy: 203.24,
    rx: 16.53,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-53",
    cx: 103.54,
    cy: 203.24,
    rx: 15.64,
    ry: 1.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-76",
    cx: 103.54,
    cy: 203.24,
    rx: 14.76,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-106",
    cx: 103.54,
    cy: 203.24,
    rx: 13.87,
    ry: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m59.59,27.05h0c4.5,0,8.81,1.79,11.99,4.98l47.79,49.72c1.34,1.48,3.68,1.48,5.02,0l45.08-46.92C152.64,13.62,126.65,0,97.47,0,46.71,0,5.57,41.14,5.57,91.89s41.14,91.89,91.89,91.89c23.85,0,45.58-9.09,61.91-23.99v-63.69c0-1.51-1.83-2.27-2.89-1.2l-29.5,33.9c-2.7,3.1-7.52,3.1-10.22,0l-29.5-33.9c-1.07-1.07-2.89-.31-2.89,1.2v65.73c-18.4,0-33.32-12.26-33.32-30.66V35.61c0-4.72,3.83-8.56,8.56-8.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m184.24,114.16h21.73c2.86,0,5.18,2.32,5.18,5.18v21.73c0,2.86-2.32,5.18-5.18,5.18h-21.73c-2.86,0-5.18-2.32-5.18-5.18v-21.73c0-2.86,2.32-5.18,5.18-5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m189.48,63.37h14.96c2.59,0,4.7,2.11,4.7,4.7v14.96c0,2.59-2.11,4.7-4.7,4.7h-14.96c-2.59,0-4.7-2.11-4.7-4.7v-14.96c0-2.59,2.11-4.7,4.7-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m214.47,90.51h12.32c1.83,0,3.31,1.48,3.31,3.31v12.32c0,1.83-1.48,3.31-3.31,3.31h-12.32c-1.83,0-3.31-1.48-3.31-3.31v-12.32c0-1.83,1.48-3.31,3.31-3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m211.53,44.58h8.8c1.41,0,2.56,1.15,2.56,2.56v8.8c0,1.41-1.15,2.56-2.56,2.56h-8.8c-1.41,0-2.56-1.15-2.56-2.56v-8.8c0-1.41,1.15-2.56,2.56-2.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m121.87,135.39c-.31,0-.61-.07-.92-.1,4.82,11.95,7.98,24.68,9.18,37.92,9.06-3.64,17.52-8.78,25-15.32v-54.95l-24.94,28.66c-2.1,2.41-5.13,3.79-8.32,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m97.47,4.25c-33.79,0-63.15,19.23-77.77,47.3,9.38,1.8,18.45,4.56,27.08,8.23v-24.18c0-7.06,5.75-12.81,12.81-12.81,5.59,0,11.05,2.27,15.06,6.29l47.23,49.14,41.9-43.6C147.08,15.28,123.12,4.25,97.47,4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m205.98,116.94h-21.73c-1.32,0-2.39,1.08-2.39,2.4v21.73c0,1.32,1.07,2.4,2.39,2.4h21.73c1.32,0,2.4-1.08,2.4-2.4v-21.73c0-1.32-1.08-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m189.48,66.16h14.96c1.06,0,1.91.86,1.91,1.91v14.96c0,1.06-.86,1.91-1.91,1.91h-14.96c-1.06,0-1.91-.86-1.91-1.91v-14.96c0-1.06.86-1.91,1.91-1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m226.79,93.29h-12.32c-.29,0-.52.24-.52.53v12.32c0,.29.24.53.52.53h12.32c.29,0,.52-.24.52-.53v-12.32c0-.29-.23-.53-.52-.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 211.53,
    y: 47.14,
    width: 8.58,
    height: 8.58
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset 1.d8efcdd02433365da72c841329cfdc65.svg";
export { ForwardRef as ReactComponent };